/** Valve Body Specialties — bright logo-aligned shop tokens (matches mobile vbsus/mx). */
export const VBS = {
  accent: "#FF5C00",
  accentHover: "#E04F00",
  accentBright: "#FF8A1A",
  accentAmber: "#FFB000",
  accentRed: "#E60012",
  accentSoft: "rgba(255, 92, 0, 0.12)",
  ink: "#0F0F12",
  inkSoft: "#181A20",
  muted: "#55575C",
  subtle: "#6E7278",
  line: "rgba(15, 15, 18, 0.08)",
  lineStrong: "rgba(15, 15, 18, 0.1)",
  canvas: "#F7F8FA",
  surface: "#FFFFFF",
  panel: "#F7F8FA",
  imageBg: "#E8EAED",
  footer: "#0F0F12",
  footerMuted: "rgba(255,255,255,0.55)",
  swoosh:
    "linear-gradient(90deg, #FFB000 0%, #FF5C00 35%, #FF1A1A 70%, #D70000 100%)",
  radius: 6,
  radiusMd: 8,
  shadowCard: "0 2px 0 rgba(15,15,18,0.06), 0 12px 28px rgba(15,15,18,0.06)",
  shadowLift: "0 4px 0 rgba(255,92,0,0.22), 0 16px 36px rgba(15,15,18,0.1)",
  headerTop: 36,
  headerMain: 72,
  fontDisplay:
    '"Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
  fontMono: 'ui-monospace, "SF Mono", "Cascadia Code", monospace',
};

export const vbsCssVars = {
  "--storefront-accent": VBS.accent,
  "--storefront-ink": VBS.ink,
  "--storefront-muted": VBS.muted,
  "--storefront-line": VBS.lineStrong,
  "--storefront-canvas": VBS.canvas,
};

export const resetButton = {
  margin: 0,
  border: 0,
  padding: 0,
  background: "none",
  font: "inherit",
  color: "inherit",
  cursor: "pointer",
  appearance: "none",
  WebkitAppearance: "none",
  textAlign: "inherit",
};

export const btnPrimary = {
  ...resetButton,
  bgcolor: VBS.accent,
  color: "#fff",
  fontWeight: 700,
  fontSize: "0.8125rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  px: 2.5,
  py: 1.35,
  borderRadius: `${VBS.radius}px`,
  boxShadow: "0 2px 0 rgba(0,0,0,0.12)",
  transition: "background-color 160ms ease, transform 120ms ease",
  "&:hover": { bgcolor: VBS.accentHover },
  "&:active": { transform: "translateY(1px)" },
};

export const btnSecondary = {
  ...resetButton,
  color: VBS.ink,
  fontWeight: 700,
  fontSize: "0.8125rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  px: 2.5,
  py: 1.35,
  borderRadius: `${VBS.radius}px`,
  border: `2px solid ${VBS.ink}`,
  transition: "background-color 160ms ease, color 160ms ease",
  "&:hover": { bgcolor: VBS.ink, color: "#fff" },
};

export const btnOnDark = {
  ...resetButton,
  bgcolor: "#fff",
  color: VBS.accent,
  fontWeight: 700,
  fontSize: "0.8125rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  px: 2.5,
  py: 1.35,
  borderRadius: `${VBS.radius}px`,
  transition: "opacity 160ms ease",
  "&:hover": { opacity: 0.92 },
};

export const labelCaps = {
  fontSize: "0.6875rem",
  fontWeight: 700,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: VBS.accent,
};

export function priceText(value, currency = "USD", quoteLabel = "Request quote") {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return quoteLabel;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}

export function resolvePrice(product) {
  const unitPrice = Number(product?.unitPrice);
  if (Number.isFinite(unitPrice) && unitPrice > 0) return product.unitPrice;
  const levels =
    product?.priceLevels && typeof product.priceLevels === "object"
      ? product.priceLevels
      : {};
  return levels.retail ?? levels.Retail ?? levels.RETAIL ?? product?.unitPrice;
}

export function normalizeTransmissions(raw) {
  const rows = raw?.data || raw || [];
  return (Array.isArray(rows) ? rows : [])
    .map((row) => row?.attributes?.name || row?.name || row?.label || "")
    .map((value) => String(value || "").trim())
    .filter(Boolean);
}
